import { ApiError } from "@/lib/api/client";
import type { PrintArtifactAction } from "@/modules/printing/renderDocument";

/**
 * THE TILL'S REPRINT (D172, roundtable 2026-10-15 T14) — pure, so the rule is
 * pinned once: a ticket that never printed goes straight to the kitchen as
 * NOT_RECEIVED; one that printed asks «لم تصل التذكرة» / «نسخة إضافية»; and a
 * station with no active printer falls back to the browser chit with the
 * answer as the paper's action — only an extra copy is a REPRINT.
 */
export type ReprintReason = "NOT_RECEIVED" | "EXTRA_COPY";

/** `printCount` counts successful `printTicket` commands (docs §7). */
export function reprintNeedsQuestion(printCount: number): boolean {
  return printCount > 0;
}

export function reprintFallbackAction(reason: ReprintReason): PrintArtifactAction {
  return reason === "EXTRA_COPY" ? "REPRINT" : "ORIGINAL";
}

/**
 * The server's 409: no print computer would print a durable job now — the
 * station has no active printer, or (gate P7 rework 2, `liveDeviceOnly`) no
 * LIVE print computer serves it. Either way the till prints its own chit.
 */
export function isStationWithoutPrinter(failure: unknown): boolean {
  return (
    failure instanceof ApiError &&
    (failure.code === "RESTAURANT_STATION_NO_PRINTER" ||
      failure.code === "RESTAURANT_STATION_PRINTER_OFFLINE")
  );
}
